//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      systemBetSelection: null,
      os: '',
      systemBetChoices: [],
      height: 0,
      marginTop: 60,
      loading: true
    }
  },
  watch: {
    selections: function (newSelections, oldSelections) {
      console.log('selectionsChange', _.size(newSelections), _.size(oldSelections))

      
      if(_.size(newSelections) == 1 && _.size(oldSelections) == 1 && this.$device.isMobile ) {
        //this.isVisible = true;
      }

      if (this.betType == 'system') {
        //this.calculateSystemBets()
      }

    },
  },
  computed: {
    showResults() {
      if (this.processingStatus) return true
      return false
    },
    processingStatus() {
        return this.$store.state.betslip.processingStatus
    },
    stakeSingle: {
      get() {
        //if we have other stakes
        return this.$store.state.betslip.stakeSingle
      },
      set(value) {
        this.$store.commit('betslip/setStakesBatch', value)
        this.$store.commit('betslip/setStakeSingle', value)
      }
    },
    lockScroll() {
      return this.isVisible && this.selectionCount > 1 && this.selectionCount < 4 && this.os == 'ios'
    },
    isVisible: {
      get() {
        return this.$store.state.betslip.visible
      },
      set(value) {
        this.$store.commit('betslip/toggleBetslip')
      }
    },
    stakeCombi: {
      get() {
        //if we have other stakes
        return this.$store.state.betslip.stakeCombi
      },
      set(value) {
        this.$store.commit('betslip/setStakeCombi', value)
      }
    },
    stakeSystem: {
      get() {
        //if we have other stakes
        return this.$store.state.betslip.stakeSystem
      },
      set(value) {
        this.$store.commit('betslip/setStakeSystem', value)
      }
    },
    betType: {
      get() {
        return this.$store.state.betslip.betType
      },
      set(value) {
        this.$store.commit('betslip/setBetType', value)
      }
    },
    total_return() {
      console.log('total_return')
      let total = 0
      if (this.betType == 'single') {
        total = this.selections.reduce((accumulator, selection) => {
          let stake = parseFloat(_.get(this.$store.state.betslip, 'stakes.' + _.get(selection, 'outcome.id'), this.stakeSingle))
          console.log('stake', stake)
          if (_.isNaN(stake)) {
            stake = 0
          }
          return accumulator + parseFloat(_.get(selection, 'outcome.odds')) * stake
        }, 0)
      }
      if (this.betType == 'combi') {
        total = this.selections.reduce((accumulator, selection) => {
          return accumulator * parseFloat(_.get(selection, 'outcome.odds'))
        }, 1)
        total = total * this.stakeCombi
      }
      if (this.betType == 'system') {
        total = this.systemBetSelection.potential_return * this.total_stake
      }
      return total
    },
    total_stake() {
      let total = this.stake
      if (this.betType == 'single') {
        total = this.selections.reduce((accumulator, selection) => {
          let stake = parseFloat(_.get(this.$store.state.betslip, 'stakes.' + _.get(selection, 'outcome.id'), this.stake))
          if (_.isNaN(stake)) {
            stake = 0
          }
          return accumulator + stake
        }, 0)
      }
      if (this.betType == 'combi') {
        total = this.stakeCombi
      }
      if (this.betType == 'system') {
        total = this.systemBetSelection.combinations * this.stakeSystem
      }
      return total
    },
    total_bets() {
      if (this.betType == 'single') {
        return _.size(this.$store.state.betslip.selections)
      }
      if (this.betType == 'combi') {
        return 1
      }
      if (this.betType == 'system') {
        return this.systemBetSelection.combinations
      }
    },
    selections() {
      return this.$store.state.betslip.selections
    },
    selectionCount() {
      return _.size(this.selections)
    }
  },
  async mounted() {
    this.$root.$on('show_betslip', () => {
      this.setMarginTop()
    })

    const appHeight = () => {
        document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`)
    }
    window.addEventListener('resize', appHeight)
    appHeight()

    let info = await this.$CapacitorDevice.getInfo()
    this.os = info.operatingSystem;


    //Safari IOS fix
    try {
        if(this.os = 'ios') {
          window.iNoBounce = require('inobounce')
          iNoBounce.disable()
        }
    } catch(e) {

    }

  },
  methods: {
    setMarginTop() {
      if (process.client) {
        try {
          this.marginTop = document.getElementById('mobile-header-nav').getBoundingClientRect().top + document.getElementById('mobile-header-nav').getBoundingClientRect().height + 10
          this.marginTop = this.marginTop + parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sat'))
          this.height = window.innerHeight - (document.getElementById('mobile-header-nav').getBoundingClientRect().height + 10)
        } catch (e) {
        }
      }
    },
    changeStake() {
      this.$store.commit('betslip/clearStakes')
    },
    async calculateSystemBets() {
      /*betting.setSelections(this.selections)
      this.systemBetChoices = betting.generateBetTypes()
      this.systemBetSelection = _.first(this.systemBetChoices)*/
    },
    async selectBetType(betType) {
      return
      if (this.selections.length <= 2 && betType == 'system') {
        return
      }
      this.calculateSystemBets()
      this.betType = betType
    },
    async close() {
      if(this.processingStatus == 'processing')
        return false;
      if(this.showResults) {
        this.$store.commit('betslip/clear');
        this.$store.commit('betslip/setProcessingStatus', false)
      }
      this.$store.commit('betslip/toggleBetslip', false)
    },
    async openSettings() {
      this.$modal.show('modal-settings')
    },
    async clear() {
      if(this.processingStatus == 'processing')
        return false;
      this.$store.commit('betslip/clear')
      this.$store.commit('betslip/toggleBetslip', false)
    }
  }
}
